import { useDictionary } from "@adamlip/okeoke.client";
import LoginModal from "views/Login";
import useStorage from "hooks/useStorage";
import { useContext, useState } from "react";
import { UserContext } from "contexts/UserContext";
import { Button } from "@nextui-org/react";

export default function LoginButton() {
  const { getValue } = useDictionary();
  const { getSV } = useStorage();

  const { userLoggedIn } = useContext(UserContext);

  const [loginModal, setLoginModal] = useState(false);

  if (userLoggedIn == null || userLoggedIn === false || getSV("anoLoginUUID"))
    return (
      <>
        <Button
          color="primary"
          className="m-4"
          onClick={() => setLoginModal(true)}
        >
          {getValue("app_v2_login_modal_open")}
        </Button>
        {loginModal && (
          <LoginModal
            isOpen={loginModal}
            setIsOpen={setLoginModal}
            canGuestLogin={true}
          />
        )}
      </>
    );

  return null;
}
